import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clickToSave: {
    description: 'Link button text to save shipping defaults',
    defaultMessage: 'Click to save as shipping defaults for this product',
    id: 'YsifFp',
  },
  saveSuccessful: {
    description: 'ordersHeader.shippingDefaultSuccessMsg',
    defaultMessage: 'Shipping defaults saved',
    id: 'QL4sA5',
  },
});
